














































import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import ETopPageText from '@/components/ETopPageText.vue';
import {
  AuthState,
  FAQState,
  NewsState,
  UserState,
} from '@/types';

@Component({
  components: {
    ETopPageText,
  },
})
export default class Empty extends Vue {
  @State('auth') auth?: AuthState;

  @State('user') user?: UserState;

  @State('faq') faq?: FAQState;

  @State('news') news?: NewsState;

  showdebuganimation: boolean = true;

  @Action('fetchData', { namespace: 'news' }) fetchData: any;

  mounted() {
    this.fetchData().catch((error: any) => {
      console.log(error);
    });
  }
}
